import { CouponTypeCode } from "project-config/constants";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

export const couponTypeTranslate = (value?: number) => {
  if (value === undefined) return "";

  const t = getTranslateNsT("topup");
  return {
    [CouponTypeCode.GPU]: t("coupon_give_type_gpu"),
    [CouponTypeCode.CPU]: t("coupon_give_type_cpu"),
    [CouponTypeCode.Universal]: t("coupon_pages_general_coupon"),
    [CouponTypeCode.CPUQingCloud]: t("youth_recharge_coupon"),
    [CouponTypeCode.GPUQingCloud]: t("gpu_youth_recharge_coupon"),
    [CouponTypeCode.Desktop]: t("desktop_recharge_coupon"),
  }[value];
};
